import type { Ref } from 'vue'
import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}

const bgColorVariants = {
    primary: 'tw-bg-primary',
    secondary: 'tw-bg-secondary',
    accent: 'tw-bg-accent',
    info: 'tw-bg-info',
    warning: 'tw-bg-warning',
    success: 'tw-bg-success',
    error: 'tw-bg-error',
}

export type MainColorVariant = keyof typeof bgColorVariants
export const getBgColorClass = (color: MainColorVariant) =>
    bgColorVariants[color]
